<template>
  <section>
    <div v-if="basket">
      <basket-list v-for="group in basket.Files" :content="group" :title="group.Name"></basket-list>
      <basket-list :content="[]" title="Basket is empty" v-if="!basket.Files.length"></basket-list>
    </div>
  </section>
</template>

<script>
import { getBasket } from "./BasketActions";
import { getResource } from "../../vuex/helpers";
import BasketList from "./BasketList";

export default {
  vuex: {
    getters: {
      basket: state => state.basket
    },
    actions: { getBasket, getResource }
  },
  components: { BasketList },
  route: {
    data () {
      this.getBasket();
    }
  }
};
</script>



// WEBPACK FOOTER //
// Basket.vue?7192a150